module.exports = SharedDependencies.ReactDOM['application-83abc821'];